import ActionTypes from '../actionTypes/actionTypes';

export const setDataReload = (reload) => ({
    type: ActionTypes.SET_DATA_RELOAD,
    reload
});